// ── Milestones Engine ──────────────────────────────────────────────────────
// Milestone tidak nyimpen nilai sendiri — cuma nunjuk ke grup investasi
// dan agregat ulang getCurrent() dari situ tiap kali dirender. Jadi progress
// selalu real-time ngikutin harga terbaru di menu Investasi, tanpa sinkronisasi manual.

import { getCurrent } from "./investments";

const DAY_MS = 86400000;

/**
 * @param {object} milestone { id, name, icon, groupNames:[], targetAmount, targetDate }
 * @param {array} investments
 * @returns progress detail siap-pakai buat UI
 */
export function getMilestoneProgress(milestone, investments) {
  const groupSet = new Set(milestone.groupNames || []);
  const items = groupSet.size === 0
    ? investments // "Semua grup" kalau kosong
    : investments.filter(i => groupSet.has(i.group || "Lainnya"));

  const current = items.reduce((a, i) => a + getCurrent(i), 0);
  const target  = milestone.targetAmount || 0;
  const pct     = target > 0 ? Math.min(current / target, 1) : 0;
  const isComplete = target > 0 && current >= target;

  let daysLeft = null, isOverdue = false, requiredMonthly = null;
  if (milestone.targetDate) {
    const diff = (new Date(milestone.targetDate).setHours(0,0,0,0) - new Date().setHours(0,0,0,0)) / DAY_MS;
    daysLeft = Math.round(diff);
    isOverdue = daysLeft < 0 && !isComplete;
    if (!isComplete) {
      const monthsLeft = Math.max(daysLeft, 1) / 30.44;
      requiredMonthly = Math.max(target - current, 0) / monthsLeft;
    }
  }

  return {
    current, target, pct, isComplete, isOverdue,
    remaining: Math.max(target - current, 0),
    daysLeft, requiredMonthly,
    itemCount: items.length,
  };
}

export function splitMilestones(milestones, investments) {
  const withProgress = milestones.map(m => ({ ...m, progress: getMilestoneProgress(m, investments) }));
  return {
    active:    withProgress.filter(m => !m.progress.isComplete).sort((a,b) => b.progress.pct - a.progress.pct),
    completed: withProgress.filter(m =>  m.progress.isComplete),
  };
}
